import { renderToStaticMarkup } from "react-dom/server";
import { getCitationFilePath } from "../../api";


// for DocSearch
type HtmlParsedAnswer = {
    answerHtml: string;
    citations: string[];
    followupQuestions: string[];
};


export function parseAnswerToHtml(answer: string, onCitationClicked: (citationFilePath: string) => void): HtmlParsedAnswer {
    const citations: string[] = [];
    const followupQuestions: string[] = [];

    // Extract any follow-up questions that might be in the answer
    let parsedAnswer = answer.replace(/<<([^>>]+)>>/g, (match, content) => {
        followupQuestions.push(content);
        return "";
    });

    // trim any whitespace from the end of the answer after removing follow-up questions
    parsedAnswer = parsedAnswer.trim();

    const parts = parsedAnswer.split(/\[([^\]]+)\]/g);

    const fragments: string[] = parts.map((part, index) => {
        const parts = part.split("/");
        part = parts[parts.length - 1];

        if (index % 2 === 0) {
            return part;
        } else {
            let citationIndex: number;
            if (citations.indexOf(part) !== -1) {
                citationIndex = citations.indexOf(part) + 1;
            } else {
                citations.push(part);
                citationIndex = citations.length;
            }

            const path = getCitationFilePath(part);

            return renderToStaticMarkup(
                <a className="supContainer" title={part} onClick={() => onCitationClicked(path)}>
                    <sup>{citationIndex}</sup>
                </a>
            );
        }
    });

    return {
        answerHtml: fragments.join(""),
        citations,
        followupQuestions
    };
}


// for Chat
type HtmlChatParsedAnswer = {
    answerHtml: string;
};


export function parseChatAnswerToHtml_old(answer: string): HtmlChatParsedAnswer {
    // trim any whitespace from the end of the answer after removing follow-up questions
    const parsedAnswer = answer.trim();

    const parts = parsedAnswer.split(/\[([^\]]+)\]/g);

    const fragments: string[] = parts.map((part, index) => {
        return part;
    });

    return {
        answerHtml: fragments.join("")
    };
}










// URL末尾の句読点を分離
function splitTrailingPunctuation_old(url: string): {
    cleanUrl: string;
    trailing: string;
} {
    const match = url.match(/[。、，．,.!?！？）)\]}]*$/);

    if (!match) {
        return {
            cleanUrl: url,
            trailing: ""
        };
    }

    const trailing = match[0];

    return {
        cleanUrl: url.slice(0, -trailing.length),
        trailing
    };
}



function splitTrailingPunctuation(url: string): {
    cleanUrl: string;
    trailing: string;
} {
    const match = url.match(/[。、，．,.!?！？）)\]}]+$/);

    if (!match || match[0].length === 0) {
        return {
            cleanUrl: url,
            trailing: ""
        };
    }

    const trailing = match[0];

    return {
        cleanUrl: url.slice(0, -trailing.length),
        trailing
    };
}









function convertChatLinks(html: string): string {
    console.log("★★ convertChatLinks 開始");

    const parts = html.split(/(<[^>]+>)/g);

    const result = parts.map((part) => {

        // HTMLタグ
        if (part.startsWith("<") && part.endsWith(">")) {
            return part;
        }

        // URLを探す
        return part.replace(
            /https?:\/\/[^\s<>"']+/g,
            (url) => {
                console.log("★★ URLを検出:", url);

                const { cleanUrl, trailing } =
                    splitTrailingPunctuation(url);

                console.log("★★ cleanUrl:", cleanUrl);

                try {
                    const urlObj = new URL(cleanUrl);

                    const htmlLink =
                        `<a href="${cleanUrl}" ` +
                        `target="_blank" ` +
                        `rel="noopener noreferrer">` +
                        `${urlObj.hostname}` +
                        `</a>` +
                        trailing;

                    console.log("★★ リンク生成:", htmlLink);

                    return htmlLink;

                } catch (error) {
                    console.log("★★ URL変換エラー:", error);
                    return url;
                }
            }
        );
    }).join("");

    console.log("★★ convertChatLinks 結果:", result);

    return result;
}




// Chat回答
export function parseChatAnswerToHtml_o(answer: string): HtmlChatParsedAnswer {

    const parsedAnswer = answer.trim();

    return {
        answerHtml: convertChatLinks(parsedAnswer)
    };
}


export function parseChatAnswerToHtml(answer: string): HtmlChatParsedAnswer {

    const parsedAnswer = answer.trim();

    console.log("★ parseChatAnswerToHtml が呼ばれています");
    console.log("★ 元データ:", parsedAnswer);

    const converted = convertChatLinks(parsedAnswer);

    console.log("★ 変換後:", converted);

    return {
        answerHtml: converted
    };
}
